module.exports = __webpack_public_path__ + "media/images/empty-image-16497700031e310728f21408f01fdce8.jpg";